import {
  AusschreibungCard as CardType,
  AusschreibungSpalte,
  AusschreibungSpalteConfig,
} from '../../types/stellenausschreibung';
import { InfoTooltip } from '../common/InfoTooltip';
import { AusschreibungCard } from './AusschreibungCard';

interface Props {
  spalte: AusschreibungSpalte;
  cards: CardType[];
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  /** Reicht das Board durch: ob die Website überhaupt bedient werden kann. */
  websitePublishVerfuegbar: boolean;
}

export function AusschreibungColumn({
  spalte,
  cards,
  isCollapsed,
  onToggleCollapse,
  websitePublishVerfuegbar,
}: Props) {
  const config = AusschreibungSpalteConfig[spalte];

  if (isCollapsed) {
    return (
      <div
        onClick={onToggleCollapse}
        title={`${config.label} — ${config.description}`}
        role="button"
        aria-expanded={false}
        aria-label={`${config.label} ausklappen`}
        data-testid={`spalte-${spalte}`}
        data-collapsed="true"
        className="w-10 flex-shrink-0 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 flex flex-col items-center py-3 transition-all duration-200 min-h-[200px] xl:h-full"
      >
        <span
          className={`inline-flex items-center justify-center h-5 min-w-[20px] px-1.5 rounded-full text-xs font-medium ${config.bgColor} ${config.color}`}
        >
          {cards.length}
        </span>
        <div className="mt-3">
          <span
            className={`text-sm font-medium ${config.color} whitespace-nowrap`}
            style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
          >
            {config.label}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      className="w-60 flex-shrink-0 bg-gray-50 rounded-lg flex flex-col max-h-[70vh] xl:max-h-none xl:h-full"
      data-testid={`spalte-${spalte}`}
      data-collapsed="false"
    >
      <div className="px-3 py-2 border-b border-gray-200 flex items-center justify-between">
        <div className="flex items-center gap-1 min-w-0">
          <button
            type="button"
            onClick={onToggleCollapse}
            title="Spalte einklappen"
            className="text-gray-400 hover:text-gray-600 shrink-0"
          >
            ‹
          </button>
          <h3 className={`text-sm font-medium truncate ${config.color}`}>
            {config.label}
          </h3>
          <InfoTooltip text={config.description} />
        </div>
        <span
          className={`shrink-0 inline-flex items-center justify-center h-5 min-w-[20px] px-1.5 rounded-full text-xs font-medium ${config.bgColor} ${config.color}`}
        >
          {cards.length}
        </span>
      </div>

      <div className="flex-1 overflow-y-auto p-2 space-y-2">
        {cards.length === 0 ? (
          <p className="py-6 text-center text-xs text-gray-400">Nichts zu tun</p>
        ) : (
          cards.map((card) => (
            <AusschreibungCard
              key={card.refId}
              card={card}
              websitePublishVerfuegbar={websitePublishVerfuegbar}
            />
          ))
        )}
      </div>
    </div>
  );
}
